import { notifyErrorWith } from "@/common/notify";
import { useCollection, usePinnedCollections } from "@/api/hooks";
import { useSetCollectionPinMutation } from "@/api/api";
import { useAppSelector } from "@/state/redux/hooks";
import { selectMe } from "@/state/redux/slices/ui";
import { Switch } from "../switch";
import { Field, FieldContent, FieldDescription, FieldLabel } from "../field";

export default function CollectionPinToggle() {
  const collection = useCollection();
  const me = useAppSelector(selectMe);
  const { pinned, slots, atCap, exempt } = usePinnedCollections();
  const [setPin] = useSetCollectionPinMutation();

  // Pinning is a personal affordance — only for your own collections.
  if (!collection || collection.user_id !== me?.id) return null;

  const isPinned = collection.pin_position !== null;
  const disabled = !isPinned && atCap;

  return (
    <Field orientation="horizontal">
      <FieldContent>
        <FieldLabel
          htmlFor="collectionPin"
          className="text-[13.5px] font-semibold"
        >
          Pinned
        </FieldLabel>
        <FieldDescription className="text-[12px]">
          {isPinned
            ? "Shown at the top of the sidebar for quick access"
            : atCap
              ? `Limit reached (${pinned.length}/${slots} pinned)`
              : `Quick access from the sidebar (${pinned.length}${exempt ? "" : `/${slots}`} pinned)`}
        </FieldDescription>
      </FieldContent>
      <Switch
        id="collectionPin"
        checked={isPinned}
        disabled={disabled}
        onCheckedChange={(checked) =>
          setPin({ collectionID: collection.id, isPinned: checked })
            .unwrap()
            .catch(
              notifyErrorWith(
                checked
                  ? "Couldn't pin the collection"
                  : "Couldn't unpin the collection",
              ),
            )
        }
      />
    </Field>
  );
}
